// 引入api请求方法
import { oneTicketRebatelist, oneTicketRebateCount } from '@/api/freight';
import { getProjectListByBid } from '@/api/project';
import { postRoutePageList } from '@/api/routeInfo';
import { orderUseoil } from '@/utils/selectCom.js';

const storeModuleName = 'chargeBackModule';

const state = {
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectId',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'autocomplete',
      param: 'orderId',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'date-picker',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'strCreateTime',
      params: ['strCreateTime', 'endCreateTime'],
    },
    {
      style: 'input-multiple',
      param: 'waybillNo',
      value: '',
      valueType: 'string',
      label: '运单编号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单编号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'driverName',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicleNo',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'select',
      param: 'consumeStatus',
      value: '',
      valueType: 'string',
      state: 'orderUseoil',
      label: '运单用油',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
  ],
  // 接口调用参数
  postParams: {
    page: 1,
    size: 20,
  },
  rebateStatus: '1',
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单信息',
        prop: 'waybillNo',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillNo',
      },
      {
        label: '运力信息',
        prop: 'driverName',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-driverName',
      },
      {
        label: '运费信息（元）',
        prop: 'freight',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-freight',
      },
      {
        label: '分油比例（%）',
        prop: 'oilPer',
        width: 80,
        checked: 1,
        sortable: true,
      },
      {
        label: '运单用油（元）',
        prop: 'oilUseMoney',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-oilUseMoney',
      },
      {
        label: '服务费降点（%）',
        prop: 'decreasePer',
        width: 80,
        checked: 1,
        sortable: true,
      },
      {
        label: '需返还金额（元）',
        prop: 'rebateAmount',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-rebateAmount',
      },
      {
        label: '备注',
        prop: 'remark',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-remark',
      },
    ],
  },
  listBackData: {
    total: '',
    rebateAmount: '',
  },
  companyList: [], // 企业列表
  orderUseoil, // 运单用油的选项
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.multiple && item.value === 'string') {
        params[item.param] = item.value.toString();
      } else {
        params[item.param] = item.value;
      }

      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    const { data } = await oneTicketRebatelist(
      Object.assign({}, params, context.state.postParams, {
        rebateStatus: context.state.rebateStatus,
      }),
    );
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data, { list: data && data.records }),
    });
  },
  getCount: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.multiple && item.value === 'string') {
        params[item.param] = item.value.toString();
      } else {
        params[item.param] = item.value;
      }

      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    const { data } = await oneTicketRebateCount(
      Object.assign({}, params, context.state.postParams, {
        rebateStatus: context.state.rebateStatus,
      }),
    );
    context.commit('updateState', {
      key: 'listBackData',
      value: Object.assign({}, context.state.listBackData, data),
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await postRoutePageList({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
};

// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'projectId':
        state.postParams.projectId = payload.id;
        break;
      case 'orderId':
        state.postParams.orderId = payload.orderId;
        break;
      default:
        break;
    }
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
